import { decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsCacheKeys } from "../decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActions/constants";
import type { AllRouteEndpoints } from "../routeTypes";

export const decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionId =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/dimensions/:dimension/actions/:action_id" as const;

/** Updating a single action leaves exactly the reads stale that a write on the
 *  collection leaves stale, so the two share one list. */
export const decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdCacheKeys: AllRouteEndpoints[] =
  decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsCacheKeys;
